import { DYNAMIC_REPORTS_ARE_FETCHING, DYNAMIC_REPORTS_GET_SUCCESS, DYNAMIC_REPORTS_GET_ERROR } from './constants';

// Initial State
export const initialState = {
  isFetching: false,
  info: {},
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DYNAMIC_REPORTS_ARE_FETCHING:
      return { ...state, isFetching: true, error: null };

    case DYNAMIC_REPORTS_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        info: action.payload || {}
      };

    case DYNAMIC_REPORTS_GET_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};
